import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {
  StyleSheet,
  Text,
  View,
} from 'react-native';
import {Button} from '../../../components/core/Button';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {isMobile} from '../../../utils/commonMethods';
import {globalImport} from '../../../common/globalImports';
import LoginVerify from '../../Login/childComponents/LoginVerify';
import {useNavigation} from '@react-navigation/native';
import {globalConst, globalConfigurableData} from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';

function ChangeNumber({mobVerfiedCallback, mob, isAddMoney}) {
  const [changeMobNumber, setChangeMobNumber] = useState(false);
  const navigation = useNavigation();
  let userInfo = useSelector(({profile}) => profile.profileData);

  return (
    <>
      {!changeMobNumber ? (
        <View style={styles.container}>
          <View style={styles.contentContainer}>
            <FormTextLabel
              labelStyles={styles.title}
              label={isAddMoney ? 'Add Money to' : 'Withdrawal will be processed to'}
            />
            
            <View style={styles.phoneContainer}>
              <Text style={styles.phoneNumber}>
                {userInfo?.isd_code} {mob}
              </Text>
            </View>

            <FormTextLabel
              labelStyles={styles.confirmText}
              label={'Is this correct?'}
            />
          </View>

          <View style={styles.buttonContainer}>
            <Button
              variant="primary"
              onPress={() => {
                mobVerfiedCallback();
              }}
              style={styles.confirmButton}
            >
              Confirm
            </Button>
            <Button
              variant="outline"
              onPress={() => {
                setTimeout(() => {
                  setChangeMobNumber(true);
                }, globalConst?.buttonTimer);
              }}
              style={styles.changeButton}
            >
              No, Change Details
            </Button>
          </View>
        </View>
      ) : (
        <LoginVerify
          isAddMoney={isAddMoney}
          mobVerfiedCallback={val => {
            mobVerfiedCallback(val);
          }}
        />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: globalConfigurableData.globalThemeColor,
    padding: 20,
  },
  contentContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 20,
  },
  title: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.secondaryTextColor1,
    textAlign: 'center',
    marginBottom: 16,
  },
  phoneContainer: {
    backgroundColor: globalConfigurableData.cardBgColor,
    borderRadius: 12,
    padding: 16,
    marginVertical: 16,
    width: '100%',
    borderWidth: 1,
    borderColor: globalConfigurableData.borderColor,
  },
  phoneNumber: {
    ...globalFontStyle.appFontTitle,
    color: globalConfigurableData.primaryTextColor1,
    textAlign: 'center',
  },
  confirmText: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.secondaryTextColor1,
    marginTop: 8,
  },
  buttonContainer: {
    width: '100%',
    gap: 12,
  },
  confirmButton: {
    marginBottom: 12,
  },
  changeButton: {
    marginBottom: isMobile() ? 20 : 0,
  },
});

export default ChangeNumber;
